import { useCallback } from 'react'

import { SimpleInput } from '@makyoapp/makyo-ui'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'
import { BuilderComponentSetting } from '@/shared/builder/types/settings'

interface TextFieldSettingProps {
  id: string
  settingId: string
  value: any
  componentId: string
  textSettings?: BuilderComponentSetting['textSettings']
}

let timeout: NodeJS.Timeout | null = null

// New Component
const TextFieldSetting = ({ textSettings, settingId, value, id, componentId }: TextFieldSettingProps) => {
  const { activeLayerClient } = useActiveLayerContext()

  const updateValue = useUpdateCompSettingValue(id)

  const { prefix, suffix, shouldUpdateComponentTitle, maxChars } = textSettings ?? {}

  const handleRename = useCallback(
    (componentId: string, newName: string) => {
      if (!activeLayerClient) return

      const component = activeLayerClient.componentsMap.get(componentId)
      if (!component) return

      component.Rename(newName)
    },
    [activeLayerClient]
  )

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (timeout) {
      clearTimeout(timeout)
    }

    const value = e.currentTarget.value

    if (!!maxChars && value.length > maxChars) {
      return
    }

    await updateValue(value)

    if (shouldUpdateComponentTitle) {
      timeout = setTimeout(() => {
        handleRename(componentId, value)
      }, 800)
    }
  }

  return (
    <SimpleInput
      className='dark:border dark:border-gray-600'
      before={prefix}
      after={suffix}
      value={value ?? ''}
      id={settingId}
      onChange={handleChange}
      type='text'
      withCounterConfig={maxChars ? { min: 1, max: maxChars } : undefined}
    />
  )
}

export default TextFieldSetting
